import template   from './reset-password.html'
import controller from './reset-password.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/reset-password/reset-password.component.js